(function ($) {
  const initializeBlock = function ($block) {
    const $slider = $block.find(".testimonials");
      if ($slider.hasClass('slick-initialized'))
        $slider.slick('unslick');

    $slider.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      adaptiveHeight: true,
      fade: true,
      //   prevArrow: $block.find(".slick-prev"),
      //   nextArrow: $block.find(".slick-next"),
    });
  };

  $(document).ready(function () {
    $(".block--testimonial").each(function () {
      initializeBlock($(this));
    });
  });

  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=testimonial",
      initializeBlock
    );
  }
})(jQuery);
